import React, { useState, useEffect } from 'react';

import { Typography } from '@mui/material';

import './SubscriptionPlans.scss';
import { useGetMeMutation } from '../../../../common/apis/CommonApi';
import { useAppSelector } from '../../../../common/hooks/reduxHooks';
import { AVAILABLE_SUBSCRIPTIONS } from '../../../constants/Purchases';
import { AvailableAppSubscription } from '../../../types/AvailableAppSubscription';
import { SubscriptionType } from '../../../types/SubscriptionType';
import SubscriptionConfirmationModal from '../Modals/SubscriptionConfirmationModal';
import SubscriptionPurchasedModal from '../Modals/SubscriptionPurchasedModal';
import UnsubscribeFirstModal from '../Modals/UnsubscribeFirstModal';
import SubscriptionCell from '../SubscriptionCell/SubscriptionCell';

const SubscriptionPlans: React.FC = () => {
  const { user } = useAppSelector((state) => state.model);
  const [getMeMutation] = useGetMeMutation();

  const [subscriptionPurchasedModal, setSubscriptionPurchasedModal] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [askToUnsubscribeFirst, setAskToUnsubscribeFirst] = useState(false);
  const [confirmSubscription, setConfirmSubscription] = useState(false);
  const [planBeingPurchased, setPlanBeingPurchased] =
    useState<SubscriptionType>(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const session = urlParams.get('session');
    if (session) {
      window.history.replaceState(null, '', window.location.pathname);
      setSubscriptionPurchasedModal(true);
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 2500);
    }
  }, []);

  const purchaseSubscription = async (
    subscriptionPlan: AvailableAppSubscription
  ) => {
    if (!user) return;

    if (
      user.activeSubscriptionType &&
      user.activeSubscriptionType !== 'trial'
    ) {
      // Ask to unsubscribe before subscribing to a new subscription
      setAskToUnsubscribeFirst(true);
      return;
    }

    setPlanBeingPurchased(subscriptionPlan.type);
    setConfirmSubscription(true);
  };

  const cancelPurchase = () => {
    setPlanBeingPurchased(null);
    setConfirmSubscription(false);
  };

  const confirmPurchase = () => {
    let stripeUrl;

    if (planBeingPurchased === 'mobile') {
      stripeUrl = process.env.REACT_APP_STRIPE_MOBILE_PLAN_URL;
    } else if (planBeingPurchased === 'desktop') {
      stripeUrl = process.env.REACT_APP_STRIPE_DESKTOP_PLAN_URL;
    }

    if (!stripeUrl) {
      alert('There has been a problem. Please try again later!');
    } else {
      window.location.assign(stripeUrl);
    }
  };
  return (
    <div>
      <div>
        <Typography fontWeight={600} color={'primary'} fontSize={24}>
          Buy subscription plan
        </Typography>
        <Typography
          fontWeight={400}
          color={'secondary'}
          fontSize={18}
          style={{ marginTop: '8' }}
        >
          Select the plan that suits you
        </Typography>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'center',
          flexWrap: 'wrap',
          width: '100%',
        }}
      >
        {user &&
          AVAILABLE_SUBSCRIPTIONS.map((plan) => (
            <SubscriptionCell
              subscription={plan}
              activeSubscriptionType={user.activeSubscriptionType}
              key={plan.product_id}
              onPressSubscribe={(subscriptionPlan: AvailableAppSubscription) =>
                purchaseSubscription(subscriptionPlan)
              }
            />
          ))}
      </div>
      <SubscriptionPurchasedModal
        open={subscriptionPurchasedModal}
        loading={loading}
        onClose={() => {
          getMeMutation();
          setSubscriptionPurchasedModal(false);
        }}
        // subscription={subscriptionBeingPurchased}
      />
      {user && (
        <>
          <UnsubscribeFirstModal
            open={askToUnsubscribeFirst}
            onClose={() => setAskToUnsubscribeFirst(false)}
          />
          <SubscriptionConfirmationModal
            open={confirmSubscription}
            onClose={() => cancelPurchase()}
            onConfirm={() => confirmPurchase()}
            email={user.email}
          />
        </>
      )}
    </div>
  );
};

export default SubscriptionPlans;
